import { PanelMember } from '../panel-member.model';
import { Candidate } from '../candidate.model';
import { DatePipe, Time } from '@angular/common';

export class Panel {
    panelMemberId: number;
    candidateId: number;
    feedback: string;
    panelId: number;
    panelName: string;
    roomNo: string;
    meetingLink: string;
    panelMemberIds: PanelMember[];
    candidateIds: Candidate[];
    assignedCnt: number;
    selectedCnt: number;
    rejectedCnt: number;
    panelCandidates: [];
    panelPanelMembers: [];

    constructor(panelName: string, roomNo: string, panelMemberIds: PanelMember[], candidateIds: Candidate[], meetingLink: string = null) {
        this.panelName = panelName;
        this.roomNo = roomNo;
        this.panelMemberIds = panelMemberIds;
        this.candidateIds = candidateIds;
        this.meetingLink = meetingLink || null;
    }
}
